import { render, staticRenderFns } from "./changeDutyNew.vue?vue&type=template&id=6d70a5ca&scoped=true"
import script from "./changeDutyNew.vue?vue&type=script&lang=js"
export * from "./changeDutyNew.vue?vue&type=script&lang=js"
import style0 from "./changeDutyNew.vue?vue&type=style&index=0&id=6d70a5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70a5ca",
  null
  
)

export default component.exports